import type { BillingInterval, PlanDuration } from '@weft/types';
import { BILLING_INTERVALS } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';

const MONTHS_IN_YEAR = 12;

export function getBillingIntervalInMonths(billingInterval: BillingInterval) {
  switch (billingInterval) {
    case BILLING_INTERVALS.Monthly: return 1;
    case BILLING_INTERVALS.BiMonthly: return 2;
    case BILLING_INTERVALS.Quarterly: return 3;
    case BILLING_INTERVALS.SixMonths: return 6;
    case BILLING_INTERVALS.Yearly: return 12;
    default: return raiseUnreachable(billingInterval);
  }
}

export function getBillingIntervalsInYear(billingInterval: BillingInterval) {
  return MONTHS_IN_YEAR / getBillingIntervalInMonths(billingInterval);
}

export function getBillingCyclesPerDurationInMonths(billingInterval: BillingInterval, planDuration: PlanDuration) {
  const billingIntervalMonths = getBillingIntervalInMonths(billingInterval);

  return Math.floor(planDuration / billingIntervalMonths);
}